import { setRem } from "@/utils/mobile.js";

export default () => {
  if (process.client) {
    setRem(document, window);
  }
};
